import { useTranslation } from 'react-i18next'
import { SubscriptionInterval } from '@/constants/wizard'
import { Toggle } from '@/components/ui/Toggle'

interface SubscriptionToggleProps {
  interval: SubscriptionInterval
  onIntervalChange: (interval: SubscriptionInterval) => void
}

export function SubscriptionToggle({ interval, onIntervalChange }: SubscriptionToggleProps) {
  const { t } = useTranslation('wizard')
  const isYearly = interval === SubscriptionInterval.YEARLY

  const handleCheckedChange = (checked: boolean) => {
    onIntervalChange(checked ? SubscriptionInterval.YEARLY : SubscriptionInterval.MONTHLY)
  }

  return (
    <Toggle
      leftLabel={t('toggle.monthly')}
      rightLabel={t('toggle.yearly')}
      checked={isYearly}
      onCheckedChange={handleCheckedChange}
      aria-label={t(isYearly ? 'toggle.yearly' : 'toggle.monthly')}
    />
  )
}
